// 大五人格测评题库

export interface BigFiveQuestion {
  id: number;
  dimension: 'openness' | 'conscientiousness' | 'extraversion' | 'agreeableness' | 'neuroticism';
  question: string;
  options: {
    a: string;
    b: string;
  };
  // 正向选项（'a' 或 'b'），表示哪个选项更符合该维度的高分表现
  positiveOption: 'a' | 'b';
}

export interface BigFiveDimension {
  key: 'openness' | 'conscientiousness' | 'extraversion' | 'agreeableness' | 'neuroticism';
  name: string;
  description: string;
  icon: string;
}

// 五个维度定义
export const bigFiveDimensions: BigFiveDimension[] = [
  {
    key: 'openness',
    name: '开放性',
    description: '对新体验、新想法的开放程度，创造力和想象力',
    icon: '🎨'
  },
  {
    key: 'conscientiousness',
    name: '尽责性',
    description: '自律、组织性和目标导向的程度',
    icon: '📋'
  },
  {
    key: 'extraversion',
    name: '外向性',
    description: '社交性、活力和积极情绪的程度',
    icon: '🎉'
  },
  {
    key: 'agreeableness',
    name: '宜人性',
    description: '合作、信任他人和同情心的程度',
    icon: '🤝'
  },
  {
    key: 'neuroticism',
    name: '神经质',
    description: '情绪稳定性、焦虑和负面情绪的程度',
    icon: '🌊'
  }
];

// 开放性维度题目 (已完成)
export const opennessQuestions: BigFiveQuestion[] = [
  {
    id: 1,
    dimension: 'openness',
    question: '面对一部你完全看不懂的、评价两极分化的实验电影，你更可能的反应是：',
    options: {
      a: '立即上网查找关于导演风格和电影的解读，试图为这份"看不懂"找到一个合理的解释。',
      b: '相信自己最直接的感受，如果觉得无聊或反感，就会中途放弃，并认为它"故弄玄虚"。'
    },
    positiveOption: 'a'
  },
  {
    id: 2,
    dimension: 'openness',
    question: '你正在规划一次时间充裕的旅行。你面前，有两种截然不同的旅行方案：',
    options: {
      a: '前往一个你从未去过的、文化完全陌生的国度。行程充满了不确定性，语言不通，甚至可能会遇到各种预料之外的麻烦。但，这也意味着，你可能会收获独一无二的、颠覆性的体验。',
      b: '重游一个你非常喜爱的、已经去过多次的城市。你可以轻车熟路地，避开所有"游客陷阱"，找到那些只有本地人才知道的小馆子，沉浸在像本地人一样生活的、舒适的体验里。'
    },
    positiveOption: 'a'
  },
  {
    id: 3,
    dimension: 'openness',
    question: '一位你非常尊敬的、你心目中的"思想导师"，发表了一篇与你现有认知，完全相悖的观点。在确认了这不是简单的"事实错误"，而是一种根本性的"世界观"差异之后，你会：',
    options: {
      a: '感到兴奋。这是你升级自己"认知系统"的绝佳机会。你会立刻投入精力，去研究他的论证过程，试图找到那个能让你的"旧模型"，与他的"新模型"，达成"兼容"的更底层的"统一理论"。',
      b: '感到一丝失落，但也更加坚定了自己的立场。你会把他从"绝对权威"的神坛上请下来。并意识到，即便是最伟大的头脑，也有其局限。而你，必须忠于自己那条独立、经过验证的思考路径。'
    },
    positiveOption: 'a'
  },
  {
    id: 4,
    dimension: 'openness',
    question: '你正在阅读一本非虚构类书籍，作者的核心观点，你非常认同。但在论证过程中，你发现了一个明显的"事实错误"——一个数据的引用，或者一个历史事件的描述，是完全错误的。这个错误，虽然不影响他最终结论的正确性，但却是一个硬伤。你会：',
    options: {
      a: '感到不适。这个"瑕疵"，破坏了整个论证过程的"严谨性"和"纯粹性"。你对这位作者的信任度，会因此而大打折扣。',
      b: '认为这"无伤大雅"。你更看重他那个具有启发性的"思想框架"。你会自动"忽略"或"脑补"掉这个小错误，继续享受这场智力盛宴。'
    },
    positiveOption: 'b'
  },
  {
    id: 5,
    dimension: 'openness',
    question: '在一次团队讨论中，一个同事，提出了一个你认为是"完全错误"的观点。你，已经准备好了，一整套，可以从逻辑上，完美地，反驳他的论据。但，就在你准备开口的前一秒，你会，更有可能：',
    options: {
      a: '直接开始你的反驳。因为，纠正一个"错误"，让讨论回到"正确"的轨道上，对你来说是当前，更高优先级的任务。',
      b: '停顿一下。然后，问他一个问题："你能不能，再多说一点，你是怎么，想到这个的？" 因为，你突然对"一个聪明人，是如何得出了一个\'错误\'结论"本身，产生了更大的兴趣。'
    },
    positiveOption: 'b'
  },
  {
    id: 6,
    dimension: 'openness',
    question: '关于"虚构作品"（小说、影视、游戏），以下哪一种，更接近于你的真实态度？',
    options: {
      a: '它们，是我生命中，不可或缺的一部分。它们，为我，提供了一个可以暂时逃离现实、去体验另一种可能性的、宝贵的"平行宇宙"。',
      b: '我很少主动去接触它们。因为，我更倾向于把有限的时间和精力，投入到"真实"的世界里。我很难对一个"虚构"的故事，产生真正的"沉浸感"。'
    },
    positiveOption: 'a'
  },
  {
    id: 7,
    dimension: 'openness',
    question: '当你在一个"半公开"的社交场合（比如，一个大的工作群），看到有人，发了一个，可能会让一部分人感到"不适"或"冒犯"的、"辣眼睛"的表情包时，你内心的第一反应，更接近于：',
    options: {
      a: '"有趣。" 我会喜欢这种，打破"沉闷"，为这个空间，注入一丝"混乱"和"活力"的、小小的"挑衅"行为。即便它也辣到我的眼睛了。',
      b: '"不妥。" 我会觉得，在公共场合，使用这种可能会引发不少人"不适"的表达方式，是一种缺乏"分寸感"的行为。'
    },
    positiveOption: 'a'
  },
  {
    id: 8,
    dimension: 'openness',
    question: '哪一种说法更像你？',
    options: {
      a: '当我发现自己犯了错时，我会感到"焦虑"。我的第一反应，是"修复"这个错误。',
      b: '当我发现自己犯了错时，我会感到"好奇"。我会觉得，我无意中闯入了一个"新大陆"。'
    },
    positiveOption: 'b'
  },
  {
    id: 9,
    dimension: 'openness',
    question: '你正在为自己的房间，挑选一幅装饰画。你会更倾向于选择：',
    options: {
      a: '一幅经典的、你非常熟悉的大师作品的复制品（比如，梵高的《星夜》）。它能唤起一种，被广泛验证过的、确定的"美感"。',
      b: '一位你从未听说过的、本地年轻艺术家的原创作品。它的风格前卫甚至刺眼，你甚至不确定自己是否"喜欢"它。只是因为它，冲击到了你。'
    },
    positiveOption: 'b'
  },
  {
    id: 10,
    dimension: 'openness',
    question: '你更认同以下哪一种，关于"智慧"的说法？',
    options: {
      a: '智慧，是"看透"。是能从所有混乱的表象中，识别出那个不变的、底层的"模式"。',
      b: '智慧，是"接纳"。是能让自己，与世界里那些，不可被解释的"神秘"和"矛盾"，和谐地"共存"。'
    },
    positiveOption: 'b'
  }
];

// 其他维度题目 (待补充)
export const conscientiousnessQuestions: BigFiveQuestion[] = [
  {
    id: 1,
    dimension: 'conscientiousness',
    question: '在你看来，"承诺"或"约定"，其本质更像：',
    options: {
      a: '一份"意向声明"。它真诚地表达了我当下的想法和意愿。但，它也应该能根据后续无法预料的"情境变化"，而进行"善意"的协商和调整。',
      b: '一份"契约"。它一旦被确立，就拥有了高于个人"情绪"和"情境"的、客观的"约束力"。履行它，是第一原则。'
    },
    positiveOption: 'b'
  },
  {
    id: 2,
    dimension: 'conscientiousness',
    question: '当你发现，因为自己的"疏忽"，而犯下一个，影响了他人的"错误"时，你内心的第一反应，更接近于：',
    options: {
      a: '一种，务实的"警醒"。你会把它看作一个需要被"解决"的"问题"，并去思考"如何安抚"或"如何平息"。',
      b: '一种，明显的"自责"和"愧疚"。你会立刻把"修正这个错误"和"弥补对方的损失"，当作自己无可推卸的责任。'
    },
    positiveOption: 'b'
  },
  {
    id: 3,
    dimension: 'conscientiousness',
    question: '在需要做出一个有风险的、重要决策时，你内心深处，更恐惧的是：',
    options: {
      a: '"犯错的风险"。因为，一个基于不完整信息的错误的决策，可能会造成无法挽回的损失。',
      b: '"错过的风险"。因为，在犹豫的时候，那个稍纵即逝的"机会窗口"，可能就永远关闭了。'
    },
    positiveOption: 'a'
  },
  {
    id: 4,
    dimension: 'conscientiousness',
    question: '一项你已经规划好的日程，被一个突发事件彻底打乱了。在处理完突发事件后，你会：',
    options: {
      a: '觉得，这正好是一个"顺理成章"的休息理由。你会想："既然计划乱了，就先放松一下吧，剩下的事，等会儿再说。"',
      b: '感到一种，必须尽快"恢复节奏"的迫切感。你会立刻，重新安排后续的所有事项，否则，内心会不得安宁。'
    },
    positiveOption: 'b'
  },
  {
    id: 5,
    dimension: 'conscientiousness',
    question: '对于一项，没有"截止日期"（Deadline）、但重要的长期任务，你的真实状态更可能是：',
    options: {
      a: '"外部事件驱动"。这件事，会一直在你的待办事项里，直到某个外部的动力发生（比如有人催促，或出现了非做不可的理由），你才会真正开始动手。',
      b: '"内部时钟驱动"。你会给自己设定一个明确的内部计划，并有节奏地向前推进。因为，完成它本身就是一种责任。'
    },
    positiveOption: 'b'
  },
  {
    id: 6,
    dimension: 'conscientiousness',
    question: '你如何看待，那些为了"长期目标"而做的、枯燥的"日常练习"（比如，背单词、练琴、健身）？',
    options: {
      a: '它们，是"基石"。你能从这种，日复一日的、确定性的"积累"中，获得一种深刻的"安心感"和"掌控感"。',
      b: '它们，是"苦役"。你知道，它们很重要，但这个过程本身极其"消耗"你的心力。你需要不断地和"放弃"的念头斗争。'
    },
    positiveOption: 'a'
  },
  {
    id: 7,
    dimension: 'conscientiousness',
    question: '在"未来的保障"和"当下的快乐"之间，你的内心天平，更倾向于：',
    options: {
      a: '"当下的快乐"。你认为，未来充满了不确定性。过度地为未来牺牲现在，是一种对生命的"辜负"。',
      b: '"未来的保障"。你愿意牺牲掉一部分眼前的"享乐"，去换取一个更有序、更稳定、更可预测的未来。'
    },
    positiveOption: 'b'
  },
  {
    id: 8,
    dimension: 'conscientiousness',
    question: '当你在看一部比较长的连续剧时，你的习惯是：',
    options: {
      a: '一旦开始，我就会觉得"有始有终"很重要，无论后面是否依然精彩，我都会坚持看完。',
      b: '如果感觉剧情开始"无聊"或"拖沓"，我会立刻弃剧，去找更有趣的东西看。'
    },
    positiveOption: 'a'
  },
  {
    id: 9,
    dimension: 'conscientiousness',
    question: '在一个深夜，你开车来到一个空无一人、也没有摄像头的红绿灯路口，你会：',
    options: {
      a: '停下来，等到绿灯亮起再走。因为"规则就是规则"，无论是否有人监督。',
      b: '在确认安全后，我会选择直接开过去。因为规则是为了安全，死板地等待没有意义。'
    },
    positiveOption: 'a'
  },
  {
    id: 10,
    dimension: 'conscientiousness',
    question: '关于"向朋友借东西"（比如，一个工具），你的真实心态更接近：',
    options: {
      a: '我会非常仔细地保管它，并尽我所能地第一时间归还。这种"未完成的义务"，会一直在我心里占据一个位置。',
      b: '我会正常地使用它，然后，在方便的时候，或者对方需要的时候，再归还。我不会对这件事持续地"惦记"。'
    },
    positiveOption: 'a'
   }
 ];

export const extraversionQuestions: BigFiveQuestion[] = [
  {
    id: 1,
    dimension: 'extraversion',
    question: '经过了一整周高强度的工作，你感到精疲力尽。到了周五晚上，你恢复"能量"的方式，更可能是：',
    options: {
      a: '去一个热闹的、朋友间的聚会。通过谈话、欢笑和互动，来"冲掉"疲惫。',
      b: '取消所有不必要的社交。一个人，安安静静地，在家呆着，休养生息。'
    },
    positiveOption: 'a'
  },
  {
     id: 2,
     dimension: 'extraversion',
     question: '当你第一次，去"认识"一个陌生人时，哪一种信息，会让你感觉更牢固地"抓住"了这个人？',
     options: {
       a: '他的"内在驱动"：他谈论某个话题时，那种不自觉的、兴奋的"神采"，以及，他话语背后，所不经意间，流露出的"价值观"。',
       b: '他的"社会坐标"：他的职业、他来自哪里、我们有什么共同的朋友……这些，能把他清晰地、锚定在"真实世界"网络中的信息。'
     },
     positiveOption: 'b'
   },
  {
    id: 3,
    dimension: 'extraversion',
    question: '当你在思考一个，对你来说非常重要的、复杂的问题时，你更倾向于：',
    options: {
      a: '找一个你信任的人，把你的想法，"说"给他听。你需要通过"口头表达"和"思想碰撞"，来理清自己的思路。',
      b: '自己一个人，进行深入的、长时间的"内部对话"。观点没有在你脑子里完全成型之前，你不想被外界打扰。'
    },
    positiveOption: 'a'
  },
  {
     id: 4,
     dimension: 'extraversion',
     question: '关于"打电话"这件事，你的感受，更接近于：',
     options: {
       a: '一种对个人"边界"和"节奏"的侵入。在打电话之前，你常常需要，先给自己做一番小小的"心理建设"。',
       b: '一种高效、直接的沟通方式。比起发一长串消息，你更倾向于，直接一个电话打过去，解决问题。'
     },
     positiveOption: 'b'
   },
  {
    id: 5,
    dimension: 'extraversion',
    question: '你认为，一段高质量的友谊，其维系的核心更在于：',
    options: {
      a: '"共同的体验"。朋友，就是，要经常一起"做事"，一起玩乐，一起经历，从而，创造出足够丰富的、鲜活的"共同记忆"。',
      b: '"深度的共鸣"。朋友，贵在，彼此之间，能提供一种，深刻的"理解"与"懂得"。即便不常联系，但你知道，那个"精神的连接"，始终都在。'
    },
    positiveOption: 'a'
  },
  {
     id: 6,
     dimension: 'extraversion',
     question: '如果你感觉，自己的生活陷入了停滞。你认为，哪条路径，更能从根本上，帮你找回"成长感"？',
     options: {
       a: '减少不必要的外部活动；给自己留出大块的、不被打扰的时间，去反思、阅读和"整理"自己的内心。你需要，通过重新建立"内部秩序"，来积蓄力量。',
       b: '去认识，更多，和自己完全不同领域的人；去尝试，更多，以前从未接触过的新鲜事物。你需要，通过极大地，丰富"外部信息"的输入，来打破僵局。'
     },
     positiveOption: 'b'
   },
  {
    id: 7,
    dimension: 'extraversion',
    question: '想象一下，你理想中，"完美的一天"，你马上想到的是：',
    options: {
      a: '"人"。和有趣的人，在一起，分享经历，交换思想。',
      b: '"空间"。拥有，完全属于你自己的、不被打扰的时间和空间。'
    },
    positiveOption: 'a'
  },
  {
    id: 8,
    dimension: 'extraversion',
    question: '对你而言，"与人交谈"这个行为，更像是一种：',
    options: {
      a: '"探索"。你对外在的世界，和他人的经验，抱有天然的好奇。交谈，是让你接触新信息、获取新刺激的、一个令人"兴奋"的过程。',
      b: '"输出"。你需要先在内心，形成一个相对清晰、完整的"自我"，然后，再通过交谈，把它"表达"出去。这个过程，需要消耗你的能量。'
    },
    positiveOption: 'a'
  },
  {
     id: 9,
     dimension: 'extraversion',
     question: '当你，听到一个，让你由衷高兴的"好消息"时（比如你成功地完成了一个大项目），你的第一反应是：',
     options: {
       a: '自己一个人，静静地"品味"和"享受"这个瞬间。你想先完整地品味这份纯粹的、属于你自己的"内在喜悦"。',
       b: '必须，立刻，找个人"分享"这份喜悦。这份快乐，只有在和他人的互动中，才能被"引爆"到最大值。'
     },
     positiveOption: 'b'
   },
  {
    id: 10,
    dimension: 'extraversion',
    question: '下面哪种对"言谈乏味"的解释，更接近你的看法？',
    options: {
      a: '有的人言谈单调乏味，因为他们兴趣狭窄，能量不足，体会不到更多姿多彩的世界。',
      b: '有的人言谈单调乏味，因为他们内心空洞，只会重复一些陈腔滥调和肤浅的信息。'
    },
    positiveOption: 'a'
  }
];

export const agreeablenessQuestions: BigFiveQuestion[] = [
  {
    id: 1,
    dimension: 'agreeableness',
    question: '一位同事，在工作中犯了一个错误，并给出了一个听起来"合情合理"的解释。你的第一反应更接近：',
    options: {
      a: '相信他。因为，在没有明确证据的情况下，应该首先，假定对方是"诚实"的。',
      b: '在脑海里，快速复盘整件事。因为，搞清楚"客观真相"，比维持表面的和谐，更重要。'
    },
    positiveOption: 'a'
  },
  {
    id: 2,
    dimension: 'agreeableness',
    question: '在餐厅排队时，你前面的人，因为一点小事，开始对服务员大声呵斥、态度非常恶劣。你的内心倾向是：',
    options: {
      a: '"他可能只是今天过得不顺罢了"。你会下意识地为这个人的行为，寻找一个"可原谅"的理由。',
      b: '"这是一个，缺乏教养的人"。你会在心里，直接给这个人下一个"负面"的定义。'
    },
    positiveOption: 'a'
  },
  {
    id: 3,
    dimension: 'agreeableness',
    question: '你认为，维系一段，长久而健康的人际关系，更重要的基石是：',
    options: {
      a: '彼此之间，那种持续的"情感连接"与"相互理解"。',
      b: '彼此之间，那个清晰的"行为边界"与"相互尊重"。'
    },
    positiveOption: 'a'
  },
  {
    id: 4,
    dimension: 'agreeableness',
    question: '在一个，你付出了"关键性"努力的团队项目中，你的上级，公开表扬了整个团队，但并没有特别点出你的贡献。你的感受更接近：',
    options: {
      a: '感到自己的功劳被"稀释"或"埋没"了。因为，一份荣誉，如果不能精准地指向具体的人，那它就没有意义。',
      b: '感到"欣慰"。你相信上级明白你的贡献。而且你赞同他的做法，你认为强调个人，反而会破坏团队的氛围。'
    },
    positiveOption: 'b'
  },
  {
    id: 5,
    dimension: 'agreeableness',
    question: '在一个和朋友的聊天中，你们就一个主观话题（比如，一部电影的优劣），产生了不同看法。对方，情绪饱满地，阐述着他的观点。你会：',
    options: {
      a: '倾向于清晰地，表达出你的"不同意"，并就你们的分歧，展开"辩论"。因为，自己的观点的"表达"，才让对话更有意义。',
      b: '倾向于点头，表示"你说的有道理"。因为，维持谈话的"和谐氛围"，比争论一个没有标准答案的"个人偏好"，更重要。'
    },
    positiveOption: 'b'
  },
  {
    id: 6,
    dimension: 'agreeableness',
    question: '当有人，向你表达一种明显"不合逻辑"的恐惧（比如，非常害怕坐飞机）时，你的第一反应是：',
    options: {
      a: '去"共情"他的"感受"。你会说："听起来，这让你非常难受吧。" 你会，先去确认，并安抚对方的"情绪"。',
      b: '去"纠正"他的"认知"。你会说："但从数据上看，飞行，其实是最安全的出行方式。" 你会尝试用"事实"和"逻辑"，去帮他驱散恐惧。'
    },
    positiveOption: 'a'
  },
  {
    id: 7,
    dimension: 'agreeableness',
    question: '周五，你正准备下班，享受周末。一位关系普通的同事找到你，希望你能帮他一个"不紧急、但很麻烦"的忙，会占用你大约一小时的"个人时间"。你会：',
    options: {
      a: '倾向于，礼貌但清晰地"拒绝"。因为，这是我的"私人时间"，保护好自己的"工作与生活边界"，是非常正当的权利。',
      b: '感觉，很难开口"拒绝"。看到别人，处在困境中，我，会下意识地，觉得，自己有"义务"去帮一下，即便会牺牲掉自己的时间。'
    },
    positiveOption: 'b'
  },
  {
    id: 8,
    dimension: 'agreeableness',
    question: '以下哪一种"社会角色"，会让你感觉，更耗费心力？',
    options: {
      a: '"安慰者"。你需要，持续地，去倾听他人的痛苦，并，不断地，向对方，提供"情感支持"。',
      b: '"谈判者"。你需要，在一个，利益对立的环境中，为了己方的目标，而进行"寸土必争"的博弈。'
    },
    positiveOption: 'b'
  },
  {
    id: 9,
    dimension: 'agreeableness',
    question: '在与人建立关系的初期，你的状态更接近：',
    options: {
      a: '"半掩的大门"。我会更多地观察对方。关于我"个人化"的信息，会非常缓慢地、有选择地，在"安全感"建立之后，才透露出去。',
      b: '"开放的窗口"。我倾向于比较快地，就分享我自己的感受、想法和经历。我认为，就算对方不是合适的人，真诚和透明，对自己并无损害。'
    },
    positiveOption: 'b'
  },
  {
    id: 10,
    dimension: 'agreeableness',
    question: '当你，被一个，你之前很信任的人辜负或伤害了之后，你的内心更接近：',
    options: {
      a: '感到巨大的"痛苦"和"困惑"，这彷佛打碎了你的世界观。',
      b: '感到非常"愤怒"，并马上把这件事，作为一个明确的"教训"。'
    },
    positiveOption: 'a'
  }
];

export const neuroticismQuestions: BigFiveQuestion[] = [
  {
    id: 1,
    dimension: 'neuroticism',
    question: '你的上级，在周五下班时，对你说："下周一早上，我们聊一下。" 然后，便离开了。在周末剩下的时间里，你的内心状态更接近：',
    options: {
      a: '"坏事躲不过。看样子可能不是坏事"。',
      b: '"这个周末都过不好了"。'
    },
    positiveOption: 'b'
  },
  {
    id: 2,
    dimension: 'neuroticism',
    question: '当你，看完一部，结局非常悲伤的电视剧之后，你的状态通常是：',
    options: {
      a: '从里面"出来"很快。你能感受到故事的悲伤，但一旦结束，你就能立刻投入"现实"。',
      b: '这种悲伤的"后劲"很足。在接下来的几个小时，甚至第二天，你依然会沉浸在它带来的情绪里。'
    },
    positiveOption: 'b'
  },
  {
    id: 3,
    dimension: 'neuroticism',
    question: '当你在开车时，被别人"加塞"，或者，在排队时，发现有人"插队"，你的内心感受更可能是：',
    options: {
      a: '一股"怒火"。你会对这种"不公正"，感到非常"愤怒"，并且，这种情绪会持续一段时间。',
      b: '一丝"不快"。你会觉得这事很讨厌，但一秒钟后，你的注意力就回到了自己正在做的事情上。'
    },
    positiveOption: 'a'
  },
  {
    id: 4,
    dimension: 'neuroticism',
    question: '在一个社交场合，你说了一句自以为有趣的"俏皮话"，但没有人笑，全场陷入了短暂的沉默。在接下来的一个小时里，你的状态更可能是：',
    options: {
      a: '"马上翻篇"。"哦，这个梗，大家没get到"，然后把这件事抛之脑后。',
      b: '"如坐针毡"。你会在内心反复地"回放"那个尴尬的瞬间。'
    },
    positiveOption: 'b'
  },
  {
    id: 5,
    dimension: 'neuroticism',
    question: '在你即将要面对一个，有挑战性的、"万众瞩目"的场合前（比如，重要的演讲、面试或比赛），你更接近：',
    options: {
      a: '"生理反应强烈"。你能清晰地感觉到自己的心跳加速、手心出汗、或者，胃部紧缩。',
      b: '"精神适度兴奋"。你会感到一丝紧张，但更多是种精神的"临战"状态，身体不会出现明显的不适。'
    },
    positiveOption: 'a'
  },
  {
    id: 6,
    dimension: 'neuroticism',
    question: '在一次公开的会议上，你的上级或一位权威人士，指出了你的一个错误。在那一刻，你的感受更接近：',
    options: {
      a: '"大脑一片空白"。你会，感到，一股热流涌上脸颊，强烈的"羞耻感"和"尴尬感"，让你，几乎无法，正常思考。',
      b: '"被事实击中"。你会，感到，一丝"不快"，但你的注意力会立刻聚焦于"如何回应"和"如何解决"，而不是"别人怎么看我"。'
    },
    positiveOption: 'a'
  },
  {
    id: 7,
    dimension: 'neuroticism',
    question: '在你，做出一个，重要的、且无法撤销的决定之后（比如，发送了一封关键邮件，订了一张不退不换的机票），你的内心状态更接近：',
    options: {
      a: '"思绪万千"。你会开始不受控制地，设想各种可能性，反复咀嚼自己是不是在哪个细节上，做得还不够好。',
      b: '"尘埃落定"。一旦决定做出，你会感到一种轻松。你会相信自己当下的判断，不再反复去想它了。'
    },
    positiveOption: 'a'
  },
  {
    id: 8,
    dimension: 'neuroticism',
    question: '你从一个你很敬重的人那里，得到了一个温和的、有建设性的"批评"。在当天剩下的时间里，你的感受更可能是：',
    options: {
      a: '"感到幸运"。也许，会有一瞬间的不快，但你马上意识到，这样的建议是很宝贵的，并思考这个建议的实质性含义。',
      b: '"隐隐作痛"。即便你知道对方是为你好，但那种"被否定"的感觉，依然会像一根小刺，在你的心里，难以释怀。'
    },
    positiveOption: 'b'
  },
  {
    id: 9,
    dimension: 'neuroticism',
    question: '当你度过了压力巨大、令人沮丧的一天后，回到家里，你的第一冲动，更倾向于：',
    options: {
      a: '虽然感觉很累，但我会去做那些真正能让我恢复精力的事情。比如，做一顿健康的晚餐、吃完饭去散散步。',
      b: '迫切地需要做一些能"立刻"让我感觉好起来的事。比如，吃点垃圾食品、刷短视频、购物等。'
    },
    positiveOption: 'b'
  },
  {
    id: 10,
    dimension: 'neuroticism',
    question: '当你，在夜深人静时，偶尔回想起，过去犯过的一些"错误"，或者一些"尴尬"的瞬间，你的体验更接近：',
    options: {
      a: '"情绪重现"。当时那种"羞愧"或"焦虑"的感觉，会再次将你笼罩。',
      b: '"只是往事"。如果再遇到类似的情境或相同的人，你认为自己，已经是另一个人了。'
    },
    positiveOption: 'a'
  }
];

// 所有题目合集
export const allBigFiveQuestions: BigFiveQuestion[] = [
  ...opennessQuestions,
  ...conscientiousnessQuestions,
  ...extraversionQuestions,
  ...agreeablenessQuestions,
  ...neuroticismQuestions
];

// 按维度获取题目
export const getQuestionsByDimension = (dimension: BigFiveDimension['key']): BigFiveQuestion[] => {
  return allBigFiveQuestions.filter(q => q.dimension === dimension);
};